<template>
  <el-form ref="baseForm" label-width="120px" :rules="baseRules" :model="baseForm">
    <h2>基本信息</h2>
    <el-divider></el-divider>
    <el-row>
      <el-form-item label="标题" prop="title">
        <el-col :span="16">
          <el-input placeholder="比赛标题" v-model.trim="baseForm.title"></el-input>
        </el-col>
      </el-form-item>
    </el-row>
    <el-row>
      <el-form-item label="比赛简介" prop="intro">
        <el-col :span="16">
          <el-input placeholder="比赛简介" v-model.trim="baseForm.intro" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }"></el-input>
        </el-col>
      </el-form-item>
    </el-row>
    <el-row>
      <el-form-item label="分类" prop="category_id">
        <el-col :span="16">
          <SelectTree :props="props" :options="category" :value="parseInt(baseForm.category_id)" @getValue="getValue($event)"></SelectTree>
        </el-col>
      </el-form-item>
      <!-- <el-tree :data="options" node-key="100" ref="etree"></el-tree> -->
    </el-row>
    <el-row>
      <el-form-item label="标签">
        <el-col :span="16">
          <!-- <el-input placeholder="请输入标签"></el-input> -->
          <el-select v-model="baseForm.tags" multiple filterable default-first-option reserve-keyword ref="tags" placeholder="请选择应用标签">
            <el-option v-for="item in tags" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-col>
      </el-form-item>
    </el-row>
    <el-row>
      <el-form-item label="主办方" prop="sponsor">
        <el-col :span="16">
          <el-input placeholder="请填写主办方" v-model.trim="baseForm.sponsor"></el-input>
        </el-col>
      </el-form-item>
    </el-row>
    <el-row v-if="courseSet.locked==='0'">
      <el-form-item label="报名方式" prop="buyType">
        <el-col :span="16">
          <!-- <el-checkbox-group v-model="baseForm.buyType">
            <el-checkbox label="个人参赛"></el-checkbox>
            <el-checkbox label="团队参赛"></el-checkbox>
          </el-checkbox-group> -->
          <el-select v-model="baseForm.buyType" placeholder="请选择">
            <el-option v-for="item in buyTypes" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-form-item>
    </el-row>
    <el-row v-if="courseSet.locked==='0'">
      <el-form-item label="报名设置" prop="buyCheck">
        <el-col :span="16">
          <el-radio-group v-model="baseForm.buyCheck">
            <el-radio label="0">不需要审核</el-radio>
            <el-radio label="1">需要审核</el-radio>
          </el-radio-group>
        </el-col>
      </el-form-item>
    </el-row>
    <el-row v-if="courseSet.locked==='0'">
      <el-form-item label="报名时间" prop="buyTime">
        <el-col :span="16">
          <el-date-picker v-model="baseForm.buyTime[0]" type="datetime" placeholder="请选择时间">
          </el-date-picker>
          &nbsp;至&nbsp;
          <el-date-picker v-model="baseForm.buyTime[1]" type="datetime" placeholder="请选择时间">
          </el-date-picker>
          <!-- <el-date-picker
            v-model="baseForm.buyTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-value="time"
            :picker-options="pickerOptions"
          >
          </el-date-picker> -->
        </el-col>
      </el-form-item>
    </el-row>
    <el-row v-if="courseSet.locked==='0'">
      <el-form-item label="比赛时间" prop="testTime">
        <el-col :span="16">
          <el-date-picker v-model="baseForm.testTime[0]" type="datetime" placeholder="请选择时间">
          </el-date-picker>
          &nbsp;至&nbsp;
          <el-date-picker v-model="baseForm.testTime[1]" type="datetime" placeholder="请选择时间">
          </el-date-picker>
          <!-- <el-date-picker
            v-model="baseForm.testTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-value="time"
            :picker-options="pickerOptions"
          >
          </el-date-picker> -->
        </el-col>
      </el-form-item>
    </el-row>
    <el-row>
      <el-form-item label="图标" prop="cover" class="red_dot">
        <el-upload class="upload-cover" drag action="/api/file/upload" accept=".jpg, .png, .gif, .JPG, .PNG, .GIF" :headers="headers()" :data="token"
          :on-success="handleCoverSuccess" :before-upload="beforeCoverUpload" :show-file-list="false">
          <i class="el-icon-upload" v-if="!cover"></i>
          <div class="el-upload__text" v-if="!cover">
            <em>点击上传</em>
          </div>
          <img v-if="cover" :src="common.filepath(cover)" class="cover" />
          <div class="el-upload__tip" slot="tip">
            建议上传200px*200px，只能上传jpg/png/gif文件，且不超过2M
          </div>
        </el-upload>
      </el-form-item>
    </el-row>
    <el-row>
      <el-form-item label="封面图片" prop="icon" class="red_dot">
        <el-upload class="upload-icon" drag action="/api/file/upload" accept=".jpg, .png, .gif, .JPG, .PNG, .GIF" :headers="headers()" :data="token" :on-success="handleIconSuccess"
          :before-upload="beforeIconUpload" :show-file-list="false">
          <i class="el-icon-upload" v-if="!icon"></i>
          <div class="el-upload__text" v-if="!icon">
            <em>点击上传</em>
          </div>
          <img v-if="icon" :src="common.filepath(icon)" class="icon" />
          <div class="el-upload__tip" slot="tip">
            建议上传480px*270px，只能上传jpg/png/gif文件，且不超过2M
          </div>
        </el-upload>
      </el-form-item>
    </el-row>
    <el-row>
      <el-form-item label="比赛详情" prop="summary">
        <el-col :span="22">
          <!-- <el-input type="textarea" :rows="5" placeholder="请输入比赛介绍"></el-input> -->
          <TinymceEditor v-model="baseForm.summary" ref="editor" :params="{ token: token.token, isWebuploader: 1 }"></TinymceEditor>
        </el-col>
      </el-form-item>
    </el-row>
    <el-row>
      <el-form-item>
        <el-col :span="22">
          <el-upload class="upload-demo" :action="
              '/api/uploadfile/upload?targetType=coursematerial&targetId=' +
                $route.params.competitionId +
                '&XDEBUG_SESSION_START=18003'
            " :before-upload="beforeFileUpload" :on-remove="handleRemove" :before-remove="beforeRemove" :data="{ token: uploadToken }" multiple :limit="5"
            :on-exceed="handleExceed" :file-list="fileList" :http-request="beforeUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-col>
      </el-form-item>
    </el-row>
    <el-divider></el-divider>
    <el-form-item>
      <el-button type="primary" @click="submitForm('baseForm', handleUpdate)" :plain="true">保存设置</el-button>
      <el-button @click="next()">下一步</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { getCategory } from "@/api/apps";
import {
  uploadFileToken,
  uploadFile,
  fileList,
  saveFile,
  deleteFile
} from "@/api/file";
import SelectTree from "@/components/TreeSelect.vue";
import TinymceEditor from "@/components/TinymceEditor";
import { getCourse, createCourse, updateCourse, searchTag } from "@/api/course";
import { getToken } from "@/utils/auth";
import qs from "qs";
export default {
  components: {
    SelectTree,
    TinymceEditor
  },
  methods: {
    next() {
      this.$router.push({
        name: "course-content"
      });
    },
    handleList() {
      fileList(this.$route.params.competitionId).then(response => {
        this.fileList = response.data.files.map(item => {
          return {
            id: item.id,
            name: item.filename
          };
        });
      });
    },
    handleIconSuccess(res, file) {
      this.icon = URL.createObjectURL(file.raw);
      this.baseForm.icon = res.uri;
    },
    beforeIconUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isGIF = file.type === "image/gif";
      if (!isJPG && !isPNG && !isGIF) {
        this.$message.error("上传封封面图片只能是 jpg、png、gif 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传封面图片大小不能超过 2M");
      }
      return isLt2M && (isJPG || isPNG || isGIF);
    },
    handleCoverSuccess(res, file) {
      this.cover = URL.createObjectURL(file.raw);
      this.baseForm.cover = res.uri;
    },
    beforeCoverUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isGIF = file.type === "image/gif";
      if (!isJPG && !isPNG && !isGIF) {
        this.$message.error("上传图标只能是 jpg、png、gif 格式!");
      }
      // if (isPNG) {
      //     this.$message.error('上传封面图片只能是 PNG 格式!');
      //   }
      // if (isJPG) {
      //     this.$message.error('上传封面图片只能是 JPG 格式!');
      //   }
      if (!isLt2M) {
        this.$message.error("上传图标大小不能超过 2M");
      }
      return isLt2M && (isJPG || isPNG || isGIF);
    },
    submitForm(formName, nextFunction) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          nextFunction();
        } else {
          return false;
        }
      });
    },
    //附件上传限制提示
    handleExceed() {
      this.$message.warning("最多上传5个附件");
    },

    //附件上传移除确定
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
    },
    handleRemove(file, fileList) {
      var data = {
        ids: [file.id],
        isDeleteFile: 1
      };

      deleteFile(this.$route.params.competitionId, qs.stringify(data)).then(
        response => {
          if (response.code === 200) {
            this.$message.success("删除成功");
          } else {
            this.$message.error("删除失败");
          }
          this.handleList();
        }
      );
    },
    //上传附件
    beforeUpload(fileData) {

      var file = fileData.file;
      var data = {
        fileName: file.name,
        fileSize: file.size
      }
      // const data = new FormData();
      // data.append("fileName", file.name);
      // data.append("fileSize", file.size);
      uploadFileToken({ token: this.uploadToken }, qs.stringify(data)).then(res => {
        var token = res.data.postParams.token;
        if (token) {
          var params = {
            targetId: this.$route.params.competitionId,
            targetType: "coursematerial",
            filename: file.name
          };
          const formData = new FormData();
          formData.append("file", file);
          formData.append("token", token);
          uploadFile(params, formData).then(response => {
            if (response.code === 200) {
              const fileRes = response.data;
              var params = {
                token: this.uploadToken
              };
              var data = {
                id: fileRes.id,
                status: "success",
                filename: fileRes.filename,
                size: fileRes.fileSize
              };
              saveFile(params, qs.stringify(data)).then(response => {
                if (response.code === 200) {
                  this.$message.success("上传成功");
                  this.handleList();
                }
              });
            }
          });
        }
      });
    },
    //
    beforeFileUpload(file) {
      const isLt100M = file.size / 1024 / 1024 <= 100;
      // const isJPG = file.type === "image/jpeg";
      // const isPNG = file.type === "image/png";
      // const isGIF = file.type === "image/gif";
      // if (!isJPG && !isPNG && !isGIF) {
      //   this.$message.error("上传封面图片只能是 jpg、png、gif 格式!");
      // }
      // if (isPNG) {
      //     this.$message.error('上传封面图片只能是 PNG 格式!');
      //   }
      // if (isJPG) {
      //     this.$message.error('上传封面图片只能是 JPG 格式!');
      //   }
      if (!isLt100M) {
        this.$message.error("上传封面图片大小不能超过 100M");
      }
      return isLt100M;
    },
    test() {
    },
    //实时搜索标签
    searchTag(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          // var params = {
          //   q: query,
          //   page_limit: 10,
          // }
          // searchTag(params).then(response => {
          //   this.loading = false;
          //   this.tagsOption = response.data;
          // });
          // this.loading = false;
          //   this.tagsOption = this.tags.filter(item => {
          //     return item.name.toLowerCase()
          //       .indexOf(query.toLowerCase()) > -1;
          //   });
        }, 200);
      } else {
        this.tagsOption = [];
      }
    },
    handleUpdate() {
      var params = [];
      params.title = this.baseForm.title;
      params.intro = this.baseForm.intro;
      params.categoryId = this.baseForm.category_id;
      params.summary = this.baseForm.summary;
      params.sponsor = this.baseForm.sponsor;
      params.tags = this.baseForm.tags.join(",");
      params.buyCheck = this.baseForm.buyCheck;
      params.buyType = this.baseForm.buyType;
      params.buyStartTime = this.baseForm.buyTime[0].getTime() / 1000;
      params.buyExpiryTime = this.baseForm.buyTime[1].getTime() / 1000;
      params.testStartTime = this.baseForm.testTime[0].getTime() / 1000;
      params.testExpiryTime = this.baseForm.testTime[1].getTime() / 1000;
      params.cover = {
        large: this.baseForm.cover,
        middle: this.baseForm.cover,
        small: this.baseForm.cover
      };
      params.icon = this.baseForm.icon;
      let that = this;
      updateCourse(this.$route.params.competitionId, qs.stringify(params)).then(
        response => {
          this.$message.success({
            message: "保存成功"
          });
          this.$emit("refresh");
          // this.$message({
          //   message: response.message,
          //   type: 'success'
          // });
        }
      );
    },
    handleTags() {
      var params = {
        q: "",
        page_limit: 10
      };
      searchTag(params).then(response => {
        this.tags = response.data.data;
      });
    },
    limitInput() {
      var input = document.getElementsByClassName("el-select__input").item(0);
      input.setAttribute("maxlength", "10");
    },

    getValue(value) {
      this.baseForm.category_id = value;
    },

    headers() {
      var token = getToken();
      return { "XX-Token": token, "XX-Device-Type": "web" };
    },
    maxLength() {
    }
  },
  data() {
    const validateIcon = (rule, value, callback) => {
      if (this.icon.length == 0) {
        callback(new Error("请上传封面"));
      } else {
        callback();
      }
    };
    const validateCover = (rule, value, callback) => {
      if (this.cover == 0) {
        callback(new Error("请上传图标"));
      } else {
        callback();
      }
    };
    const validateCategory = (rule, value, callback) => {
      if (value == 0) {
        callback(new Error("请选择分类"));
      } else {
        callback();
      }
    };
    const validateSummary = (rule, value, callback) => {
      if (value == null || value == "") {
        callback(new Error("请输入比赛详情"));
      } else {
        callback();
      }
    };
    const validateBuyTime = (rule, value, callback) => {
      if (
        value == null ||
        value[0] == "" ||
        value[0] == null ||
        value[1] == "" ||
        value[1] == null
      ) {
        callback(new Error("报名时间不能为空"));
      } else if (value[0].getTime() > value[1].getTime()) {
        callback(new Error("报名开始时间不能大于报名结束时间"));
      } else if (value[0].getTime() == value[1].getTime()) {
        callback(new Error("报名开始时间不能等于报名结束时间"));
      } else if (
        value[0].getTime() <= new Date().getTime() &&
        this.courseSet.status != "published"
      ) {
        callback(new Error("报名开始时间不能小于当前时间"));
      } else {
        callback();
      }
    };
    const validateTestTime = (rule, value, callback) => {
      if (value == null || value[0] == "" || value[1] == "") {
        callback(new Error("比赛时间不能为空"));
      } else if (value[0].getTime() > value[1].getTime()) {
        callback(new Error("比赛开始时间不能大于比赛结束时间"));
      } else if (value[0].getTime() == value[1].getTime()) {
        callback(new Error("比赛开始时间不能等于比赛结束时间"));
      } else if (value[0].getTime() <= this.baseForm.buyTime[1].getTime()) {
        callback(new Error("比赛开始时间不能小于报名结束时间"));
      } else {
        callback();
      }
    };
    return {
      baseForm: {
        title: "",
        intro: "",
        subtitle: "",
        tags: "",
        category_id: 0,
        sponsor: "",
        buyCheck: 0,
        buyType: "",
        buyTime: [],
        testTime: [],
        summary: "",
        cover: "",
        icon: "",
      },
      baseRules: {
        title: [
          { required: true, trigger: "change", message: "请输入标题" },
          {
            min: 1,
            max: 30,
            message: "请输入1-30 个字符",
            trigger: "change"
          }
        ],
        intro: [
          { max: 200, message: "长度请在 200 个字符内", trigger: "change" }
        ],
        // tags: [
        //   {required: true, trigger: "blur", validator: validateUsername}
        // ],
        category_id: [
          { required: true, trigger: "change", validator: validateCategory }
        ],
        // changeStatus: [
        //   {required: true, trigger: "blur", validator: validateUsername}
        // ],
        icon: [{ required: false, trigger: "blur", validator: validateIcon }],
        cover: [{ required: false, trigger: "blur", validator: validateCover }],
        sponsor: [
          { required: true, trigger: "change", message: "请输入主办方" },
          { max: 30, message: "长度请在 30 个字符内", trigger: "change" }
        ],
        buyType: [
          { required: true, trigger: "blur", message: "请选择报名方式" }
        ],
        buyCheck: [
          { required: true, trigger: "blur", message: "请选择报名设置" }
        ],
        buyTime: [
          { required: true, trigger: "blur", validator: validateBuyTime }
        ],
        testTime: [
          { required: true, trigger: "blur", validator: validateTestTime }
        ],
        summary: [
          { required: true, trigger: "blur", validator: validateSummary }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        }
      },
      buyTypes: [
        {
          value: "1",
          label: "个人参赛",
          id: "1"
        },
        {
          value: "2",
          label: "团队参赛",
          id: "2"
        },
        {
          value: "3",
          label: "个人和团队参赛",
          id: "3"
        },
        {
          value: "4",
          label: "手动导入",
          id: "4"
        }
      ],
      tagsOption: [],
      props: {
        // 配置项（必选）
        value: "id",
        label: "name",
        children: "children"
        // disabled:true
      },
      tags: [],
      time: [new Date(), new Date()],
      courseSet: null,
      categorys: [],
      category: null,
      loading: false,
      value: "",
      icon: "",
      cover: "",
      coverArr: null,
      imageUrl: "",
      radio: 3,
      course: "",
      token: null,
      uploadToken: "",
      fileList: []
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   getCourse(to.params.competitionId).then(response => {
  //     // 
  //     next(vm => {
  //       vm.categorys = response.data.category;
  //       vm.course = response.data.course;
  //       vm.baseForm.title = vm.course.title;
  //       vm.baseForm.subtitle = vm.course.subtitle;
  //       vm.baseForm.category_id = vm.course.category_id;
  //       vm.baseForm.tags = vm.course.tags ? vm.course.tags.split(",") : "";
  //       vm.baseForm.serialize_mode = vm.course.serialize_mode;

  //       vm.icon = vm.course.icon;
  //       vm.cover = vm.course.cover;
  //       vm.baseForm.summary = vm.course.summary;
  //     });
  //   });
  // },
  // computed:{
  //   /* 转树形数据 */
  //   optionData(){
  //     let cloneData = JSON.parse(JSON.stringify(this.list))      // 对源数据深度克隆
  //     return  cloneData.filter(father=>{                      // 循环所有项，并添加children属性
  //         let branchArr = cloneData.filter(child=>father.id == child.parentId);       // 返回每一项的子级数组
  //         branchArr.length>0 ? father.children=branchArr : ''   //给父级添加一个children属性，并赋值
  //         return father.parentId==0;      //返回第一层
  //     });
  //   }
  // },
  watch: {
    coverArr: function () {
      if (Object.keys(this.coverArr).length > 0) {
        this.cover = this.coverArr.middle;
      }
    }
  },
  created() {
    this.handleTags();
    this.handleList();
    this.course = { ...this.$attrs.course };
    this.courseSet = { ...this.$attrs.courseSet };
    this.category = this.$attrs.category;
    this.baseForm.title = this.courseSet.title;
    this.baseForm.tags = this.$attrs.tags;
    this.baseForm.category_id = this.courseSet.categoryId;
    this.baseForm.intro = this.courseSet.intro;
    this.baseForm.sponsor = this.courseSet.sponsor;
    this.coverArr = this.courseSet.cover;
    this.baseForm.icon = this.courseSet.icon;
    this.icon = this.courseSet.icon;
    if (Object.keys(this.courseSet.cover).length > 0) {
      this.baseForm.cover = this.courseSet.cover.middle;
    }

    this.token = this.$attrs.token;
    this.uploadToken = this.$attrs.uploadToken;
    this.baseForm.summary = this.courseSet.summary;
    this.baseForm.buyType = this.course.buyType;
    this.baseForm.buyCheck = this.course.buyCheck;
    this.baseForm.buyTime[0] =
      this.course.buyStartTime != "0"
        ? new Date(this.course.buyStartTime * 1000)
        : "";
    this.baseForm.buyTime[1] =
      this.course.buyExpiryTime != "0"
        ? new Date(this.course.buyExpiryTime * 1000)
        : "";
    this.baseForm.testTime[0] =
      this.course.testStartTime != "0"
        ? new Date(this.course.testStartTime * 1000)
        : "";
    this.baseForm.testTime[1] =
      this.course.testExpiryTime != "0"
        ? new Date(this.course.testExpiryTime * 1000)
        : "";
    // getCourse(this.$route.params.competitionId).then(response => {
    //   
    // });
  },

  mounted() { }
};
</script>

<style scoped>
/* .el-form {
    padding: 10px;
} */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.upload-cover >>> .el-upload-dragger {
  width: 150px;
  height: 150px;
}
.cover {
  width: 150px;
  height: 150px;
  position: absolute;
  top: 0;
  left: 0;
}

.upload-icon >>> .el-upload-dragger {
  width: 480px;
  height: 270px;
}
.icon {
  width: 480px;
  height: 270px;
  position: absolute;
  top: 0;
  left: 0;
}

.red_dot >>> .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
.avatar-uploader >>> .el-upload--picture-card {
  width: 102px;
  height: 102px;
  line-height: 100px;
  overflow: hidden;
}
</style>
